import React from "react";
import { Card, CardContent, Typography, Avatar, Box } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import teamMembers from "./teamMembers";
import "swiper/css";
import "swiper/css/pagination";

export default function TeamSlider({ language = "arabic" }) {
  const lang = language === "arabic" ? "ar" : "en";
  const isArabic = lang === "ar";

  const sectionTitle = isArabic ? "فريقنا" : "Our Team";

  return (
    <Box
      sx={{
        py: 1,
        px: 2,
        maxWidth: "1280px",
        margin: "0 auto",
        fontFamily: '"Alexandria", sans-serif',
        backgroundColor: "#f9f9f9",
        borderRadius: 4,
        boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
      }}
    >
      {/* Section Title */}
      <Typography
        variant="h4"
        align="center"
        mb={3}
        sx={{
          fontWeight: 700,
          fontSize: { xs: "24px", md: "32px" },
          color: "#333",
          lineHeight: 1.2,
          fontFamily: '"Alexandria", sans-serif',
        }}
      >
        {sectionTitle}
      </Typography>

      {/* Swiper Container */}
      <Swiper
        key={lang}
        modules={[Autoplay, Pagination]}
        spaceBetween={15}
        slidesPerView={1}
        autoplay={{ delay: 4000 }}
        pagination={{ clickable: true }}
        breakpoints={{
          640: { slidesPerView: 1 },
          768: { slidesPerView: 2 },
          1024: { slidesPerView: 3 },
        }}
        style={{ paddingBottom: "40px" }}
      >
        {teamMembers.map((member, index) => (
          <SwiperSlide key={index}>
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Card
                sx={{
                  width: "100%",
                  maxWidth: 360,
                  height: 380,
                  textAlign: isArabic ? "right" : "left",
                  px: 3,
                  pt: 4,
                  pb: 3,
                  borderRadius: 4,
                  boxShadow: "0px 6px 12px rgba(0, 0, 0, 0.1)",
                  transition: "transform 0.3s ease-in-out",
                  "&:hover": {
                    transform: "scale(1.03)",
                  },
                  direction: isArabic ? "rtl" : "ltr",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  backgroundColor: "#fff",
                  fontFamily: '"Alexandria", sans-serif',
                }}
              >
                {/* Member Avatar */}
                <Avatar
                  src={member.image}
                  alt={member.name[lang]}
                  sx={{
                    width: 80,
                    height: 80,
                    mb: 3,
                    fontSize: 24,
                    border: "3px solid #e0e0e0",
                  }}
                />

                {/* Member Details */}
                <CardContent
                  sx={{
                    p: 0,
                    textAlign: "inherit",

                    display: "flex",
                    flexDirection: "column",
                    flexGrow: 1,
                    width: "100%",
                    fontFamily: '"Alexandria", sans-serif',

                    "& > *": {
                      mb: 1,
                    },
                  }}
                >
                  <Typography
                    variant="subtitle2"
                    color="text.secondary"
                    fontSize="14px"
                    mb={1}
                    sx={{
                      lineHeight: 1.5,
                      fontFamily: '"Alexandria", sans-serif',
                    }}
                  >
                    {member.section[lang]}
                  </Typography>

                  {/* Member Name */}
                  <Typography
                    variant="h6"
                    fontSize="18px"
                    fontWeight={600}
                    mb={0.5}
                    color="#333"
                    sx={{
                      lineHeight: 1.5,
                      fontFamily: '"Alexandria", sans-serif',
                    }}
                  >
                    {member.name[lang]}
                  </Typography>

                  {/* Member Title */}
                  <Typography
                    fontSize="14px"
                    fontWeight={500}
                    color="text.secondary"
                    mb={1}
                    sx={{
                      lineHeight: 1.6,
                      fontFamily: '"Alexandria", sans-serif',
                    }}
                  >
                    {member.title[lang]}
                  </Typography>

                  {/* Member Description */}
                  <Typography
                    fontSize="14px"
                    color="text.primary"
                    sx={{
                      display: "-webkit-box",
                      WebkitLineClamp: 3,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      lineHeight: 1.9,
                      fontFamily: '"Alexandria", sans-serif',
                    }}
                  >
                    {member.description[lang]}
                  </Typography>
                </CardContent>
              </Card>
            </Box>
          </SwiperSlide>
        ))}
      </Swiper>
    </Box>
  );
}
